import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React, { useEffect, useMemo, useState } from "react";
import Default from "./components/default";
import PageHeader from "./components/header";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import DateConvert from "utils/dateConvert";
import MusicView from "./components/music-view";
import api from "services/axiosInstance";
import { toast } from "react-toastify";
import Toast from "components/toast";
import { RatedFanPageItem } from "types/ratedfansData";

export interface IFilter {
  filter: [
    { section: "Date"; filter: { to: Date | null; from: Date | null } },
    { section: "Artist"; filter: string },
    { section: "Status"; filter: string },
    { section: "Type"; filter: string }
  ];
}
const RatedFans = () => {
  const [started, setStarted] = useState(true);

  const [page, setPage] = useState(1);

  const [viewType, setViewType] = useState("music");
  const [fetching, setFetching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [data, setData] = useState<RatedFanPageItem[]>([]);
  const [searchFilter, setSearchFilter] = useState<IFilter>({
    filter: [
      { section: "Date", filter: { to: null, from: null } },
      { section: "Artist", filter: "" },
      { section: "Status", filter: "" },
      { section: "Type", filter: "" }
    ]
  });
  const resetFilterItem = (sectionToReset: string) => {
    setSearchFilter({
      filter: [
        sectionToReset === "Date"
          ? { section: "Date", filter: { from: null, to: null } }
          : searchFilter.filter[0], // Date filter

        sectionToReset === "Artist"
          ? { section: "Artist", filter: "" }
          : searchFilter.filter[1], // Artist filter

        sectionToReset === "Status"
          ? { section: "Status", filter: "" }
          : searchFilter.filter[2], // Status filter

        sectionToReset === "Type"
          ? { section: "Type", filter: "" }
          : searchFilter.filter[3] // Type filter
      ] as [
        { section: "Date"; filter: { from: Date | null; to: Date | null } },
        { section: "Artist"; filter: string },
        { section: "Status"; filter: string },
        { section: "Type"; filter: string }
      ]
    });
  };

  const GetData = async () => {
    setFetching(true);
    try {
      const response = await api.get(`/artist/ratedfans`);
      const { data } = response;
      const ratedFanPageItems: RatedFanPageItem[] = data.data;
      setData(ratedFanPageItems);
    } catch (error) {
      Toast({ error });
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const FilteredData = useMemo(() => {
    let filteredData = data;

    //search filter
    if (searchInput.length > 0) {
      filteredData = filteredData.filter(
        (item) =>
          item.artistName.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.releaseTitle.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.songTitle.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    //date filter
    if (
      searchFilter.filter[0].filter.from &&
      searchFilter.filter[0].filter.to
    ) {
      filteredData = filteredData.filter(
        (item) =>
          new Date(item.createdAt) >=
            new Date(searchFilter.filter[0].filter.from || "") &&
          new Date(item.createdAt) <=
            new Date(searchFilter.filter[0].filter.to || "")
      );
    }

    //name filter
    if (searchFilter.filter[1].filter) {
      filteredData = filteredData.filter(
        (item) => item.artistName === searchFilter.filter[1].filter
      );
    }

    //type filter
    // if (searchFilter.filter[3].filter) {
    //   filteredData = filteredData.filter(
    //     (item) => item.releaseType === searchFilter.filter[3].filter
    //   );
    // }

    return filteredData;
  }, [searchFilter, data, searchInput]);

  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="RAted Fans"
        />
        {!started && <Default />}
        {started && (
          <>
            <PageHeader
              onChangeView={(viewType) => setViewType(viewType)}
              onChangeSearch={(value) => setSearchInput(value)}
              filter={searchFilter}
              setFilter={(value) => setSearchFilter(value)}
            />
            {searchFilter.filter.length > 0 && (
              <Filters>
                {searchFilter.filter.map(({ section, filter }, i) => {
                  const to = searchFilter.filter[0].filter.to;
                  const from = searchFilter.filter[0].filter.from;

                  if (filter === "") {
                    return null; // Skip empty filter items.
                  }

                  if (i === 0) {
                    if (to === null || from === null) {
                      return null; // Skip empty date filter.
                    }
                    return (
                      <FilterItem key={i}>
                        <Typography color={Colors.grey400} size="s">
                          {section}:
                        </Typography>
                        <Typography
                          color={Colors.grey400}
                          size="s"
                          ml="0.4"
                          weight="semibold"
                        >
                          {DateConvert(from)} - {DateConvert(to)}
                        </Typography>
                        <CloseIcon
                          onClick={() => {
                            setSearchFilter({
                              filter: [
                                {
                                  section: "Date",
                                  filter: { to: null, from: null }
                                },
                                searchFilter.filter[1],
                                searchFilter.filter[2],
                                searchFilter.filter[3]
                              ]
                            });
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M9 3L3 9.00001M3 3L9 9.00001"
                              stroke="#CDCDCD"
                              stroke-width="0.642857"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </CloseIcon>
                      </FilterItem>
                    );
                  }

                  return (
                    <FilterItem
                      key={i}
                      onClick={() => resetFilterItem(section)}
                    >
                      <Typography color={Colors.grey400} size="s">
                        {section}:
                      </Typography>
                      <Typography
                        color={Colors.grey400}
                        size="s"
                        ml="0.4"
                        weight="semibold"
                      >
                        {filter}
                      </Typography>
                      <CloseIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M9 3L3 9.00001M3 3L9 9.00001"
                            stroke="#CDCDCD"
                            stroke-width="0.642857"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </CloseIcon>
                    </FilterItem>
                  );
                })}
              </Filters>
            )}
          </>
        )}
        {started && viewType === "music" ? (
          <MusicView data={FilteredData} />
        ) : null}
      </>
    </DashboardLayout>
  );
};

export default RatedFans;

const Filters = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 2rem;
`;

const FilterItem = styled.div`
  border-radius: 0.4rem;
  background: ${Colors.grey600};
  padding: 0.4rem 0.8rem;
  margin-left: 0.8rem;
  margin-top: 1.2rem;
  display: flex;
`;

const CloseIcon = styled.div`
  width: 1.2rem;
  cursor: pointer;
  margin-left: 0.4rem;
`;
